import React from 'react';
import { Box, Heading, Text } from '@bechtel/gds';
// @ts-ignore: tsc declarations not recognising types/index.d.ts
import { ReactComponent as UnderConstructionIcon } from '@bechtel/client-assets/dist/images/under-construction.svg';
import { UnderConstructionStyled } from './styled';
import { css } from 'styled-components';
import { Trans } from '@lingui/macro';

export const UnderConstruction = () => {
  return (
    <Box
      flexDirection={{ sm: 'column' }}
      justifyContent={{ sm: 'center' }}
      alignItems={{ sm: 'center' }}
      css="height: 100%;"
    >
      <UnderConstructionStyled>
        <UnderConstructionIcon
          css={`
            ${({ theme }) =>
              css`
                fill: ${theme.colors.blue[300]};
              `}
          `}
        />
      </UnderConstructionStyled>
      <Box mt={{ sm: '400' }} mb={{ sm: '500' }}>
        <Heading family="graphik" size="800" color="grey.600" weight="600">
          <Trans>Under Construction</Trans>
        </Heading>
      </Box>
      <Text family="graphik" size="600" color="grey.600">
        <Trans> We’re currently working on this page. Thanks for your patience!</Trans>
      </Text>
    </Box>
  );
};
